import React from 'react';
import { User } from '../../types';

interface AvatarProps {
  user?: User;
  /** When provided and user is missing, show initials derived from this name */
  name?: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

function initialsFromName(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0].slice(0, 1) + parts[1].slice(0, 1)).toUpperCase();
  return name.slice(0, 2).toUpperCase() || '?';
}

const Avatar: React.FC<AvatarProps> = ({ user, name, size = 'medium', className = '' }) => {
  const sizeClasses = {
    small: 'w-6 h-6 text-xs',
    medium: 'w-8 h-8 text-sm',
    large: 'w-12 h-12 text-base',
  };

  const sizeClass = sizeClasses[size];
  const displayInitials = user?.initials || (name ? initialsFromName(name) : null) || '?';

  if (user?.avatar) {
    return (
      <img
        src={user.avatar}
        alt={user.username}
        className={`inline-block ${sizeClass} rounded-full object-cover ${className}`}
      />
    );
  }

  return (
    <div className={`inline-flex items-center justify-center ${sizeClass} rounded-full bg-primary-700 text-white font-semibold ${className}`}>
      {displayInitials}
    </div>
  );
};

export default Avatar;
